// extracted by mini-css-extract-plugin
export default {"teacher":"Teachers_teacher__lnNJO","add":"Teachers_add__sbmy-","upload":"Teachers_upload__EO9IN","uploadBtn":"Teachers_uploadBtn__HmC8D"};